module.exports = __webpack_public_path__ + "static/media/013-italy.8bfa3a08.svg";